import type { UserRole } from '@/types/auth.types'

/**
 * Hint di sessione cross-origin per il sito pubblico (ollylife.com).
 *
 * NON sono credenziali: il vero stato di autenticazione resta il token Cognito
 * nel localStorage dell'app. Questi cookie, leggibili da JS, servono solo a far
 * mostrare al sito pubblico "Dashboard"/l'email invece di "Accedi". Anche se
 * forgiati, portano solo all'app, dove ProtectedRoute richiede comunque un
 * token valido. L'email è un dato dell'utente stesso, scritto nel suo browser e
 * leggibile solo da JS sui domini *.ollylife.com (nessun terzo coinvolto).
 *
 * Dominio: in produzione `.ollylife.com` (condiviso tra app.ollylife.com e
 * ollylife.com). In locale si omette il domain: un cookie host-only su
 * `localhost` è comunque condiviso fra le porte (5173 app / 3000 web).
 */
const COOKIE_NAME = 'olly_role'
const EMAIL_COOKIE_NAME = 'olly_email'

function domainAttr(): string {
  const host = window.location.hostname
  return host.endsWith('ollylife.com') ? '; domain=.ollylife.com' : ''
}

function secureAttr(): string {
  return window.location.protocol === 'https:' ? '; secure' : ''
}

export function setAuthHint(role: UserRole, email: string): void {
  const maxAge = 60 * 60 * 24 * 30 // 30 giorni
  const attrs = `; path=/; max-age=${maxAge}; samesite=lax` + domainAttr() + secureAttr()
  document.cookie = `${COOKIE_NAME}=${role}` + attrs
  document.cookie = `${EMAIL_COOKIE_NAME}=${encodeURIComponent(email)}` + attrs
}

export function clearAuthHint(): void {
  // Stesso domain/path usati in scrittura, altrimenti il cookie non viene rimosso.
  const attrs = `; path=/; max-age=0; samesite=lax` + domainAttr()
  document.cookie = `${COOKIE_NAME}=` + attrs
  document.cookie = `${EMAIL_COOKIE_NAME}=` + attrs
}
